// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor_evpve { 
  padding : 16px;
}

.grid_olv3e {
  position:relative;
  display : grid;
  grid-template-columns: 50px 100px 100px 50px;
  grid-template-rows: 50px 50px 50px 50px;
  border : 16px solid var( --color-base100, #eeeeee );
  background: var( --color-base100, #eeeeee );
  border-radius: 4px;
  column-gap : 4px;
  row-gap: 4px;
  align-self: center;
}

.grid_olv3e.vh_JCQ4z {
  grid-template-areas: var( --layoutGrid );

  NOgrid-template-areas: 
    "aux1 aux1 aux1 aux1 aux1 aux1"
    "main1 main1 main1 main2 main2 main2"
    "main1 main1 main1 main2 main2 main2"
    "aux2 aux2 aux2 aux2 aux2 aux2"
}
/* 
.grid.vh .main {
  min-height : 120px;
  min-width : 120px;
}

.grid.vh .aux {
  min-height : 40px;
  min-width : 40px;
} */

.grid_olv3e.vv__mZ1U {
  grid-template-areas: var( --layoutGrid );

  NOgrid-template-areas: 
    "aux1 aux1 aux1 aux1 aux1 aux1"
    "main1 main1 main1 main1 main1 main1"
    "main2 main2 main2 main2 main2 main2"
    "aux2 aux2 aux2 aux2 aux2 aux2"
}
/* 
.grid.vv .main {
  min-height : 120px;
  min-width : 120px;
}

.grid.vv .aux {
  min-height : 40px;
  min-width : 244px;
} */


.grid_olv3e.hh_JPKmF {
  grid-template-areas: var( --layoutGrid );

  NOgrid-template-areas: 
    "aux1 main1 main1 main2 main2 aux2"
    "aux1 main1 main1 main2 main2 aux2"
    "aux1 main1 main1 main2 main2 aux2"
    "aux1 main1 main1 main2 main2 aux2"
}
/* 
.grid.hh .main {
  min-height : 244px;
  min-width : 120px;
}

.grid.hh .aux {
  min-width : 40px;
  min-height : 244px;
} */


.grid_olv3e.hv_D2koz {
  grid-template-areas: var( --layoutGrid );

  NOgrid-template-areas: 
    "aux1 main1 main1 main1 main1 aux2"
    "aux1 main1 main1 main1 main1 aux2"
    "aux1 main2 main2 main2 main2 aux2"
    "aux1 main2 main2 main2 main2 aux2";
}


.swapMain_luKCn, .rotateMain_lvwfq {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* .rotateMain {
  position : absolute;
  top : 54px;
  right : 54px;
} */
.tlExpand_ZDO_p {
  position : absolute;
  top : 8px;
  left : 0;
}

.trExpand_OPYxt {
  position : absolute;
  top : 8px;
  right : 0;
}

.blExpand_D_npk {
  position : absolute;
  bottom : 8px;
  left : 0;
}

.brExpand_cXEc4 {
  position : absolute;
  bottom : 8px;
  right : 0;
}

.expand_M6n_P > i {
  transition : transform 0.3s ease;
}
.neg90_NU_os {
  transform :rotate(-90deg);
}

.swapMain_luKCn > *, .swapAux_RY0qk > *, .rotateMain_lvwfq > * {
  pointer-events: all;
  z-index:1;
}

.swapAux_RY0qk {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
  display: flex;
}

.swapAux-v_XATNV {
  justify-content: flex-end;
  align-items: center;
}

.swapAux-h__m54B {
  justify-content: center;
  align-items: flex-end;
}

.layout_yP422 {
  display : flex;
  align-items: center
}

.area_I_Gy8 {
  position : relative;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  justify-self: stretch;
  background: white;
  border-radius: 4px;
}
.area_I_Gy8 > * {
  z-index:2;
  /* width: 100% !important;
  height: 100% !important;
  align-items: center !important;
  justify-content: center !important;
  border : none !important; */
}
.area_I_Gy8:hover {
  background : var( --color-base050, #eeeeff )
}

.main1_qBjya {
  grid-area : main1;
}

.main2_EjfKA {
  grid-area : main2;
}

.aux1_pUaYW {
  grid-area : aux1;
}

.aux2_fCkod {
  grid-area : aux2;
}

.aux3_BY3YX {
  grid-area : aux3;
}

.aux4_CXXHD {
  grid-area : aux4;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/layout/ViewerSelector.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;EAC5C,uCAAuC;EACvC,mDAAmD;EACnD,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;;EAExC;;;;;AAKF;AACA;;;;;;;;;GASG;;AAEH;EACE,wCAAwC;;EAExC;;;;;AAKF;AACA;;;;;;;;;GASG;;;AAGH;EACE,wCAAwC;;EAExC;;;;;AAKF;AACA;;;;;;;;;GASG;;;AAGH;EACE,wCAAwC;;EAExC;;;;uCAIqC;AACvC;;;AAGA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;GAIG;AACH;EACE,mBAAmB;EACnB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT;;;;6BAI2B;AAC7B;AACA;EACE;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".editor { \n  padding : 16px;\n}\n\n.grid {\n  position:relative;\n  display : grid;\n  grid-template-columns: 50px 100px 100px 50px;\n  grid-template-rows: 50px 50px 50px 50px;\n  border : 16px solid var( --color-base100, #eeeeee );\n  background: var( --color-base100, #eeeeee );\n  border-radius: 4px;\n  column-gap : 4px;\n  row-gap: 4px;\n  align-self: center;\n}\n\n.grid.vh {\n  grid-template-areas: var( --layoutGrid );\n\n  NOgrid-template-areas: \n    \"aux1 aux1 aux1 aux1 aux1 aux1\"\n    \"main1 main1 main1 main2 main2 main2\"\n    \"main1 main1 main1 main2 main2 main2\"\n    \"aux2 aux2 aux2 aux2 aux2 aux2\"\n}\n/* \n.grid.vh .main {\n  min-height : 120px;\n  min-width : 120px;\n}\n\n.grid.vh .aux {\n  min-height : 40px;\n  min-width : 40px;\n} */\n\n.grid.vv {\n  grid-template-areas: var( --layoutGrid );\n\n  NOgrid-template-areas: \n    \"aux1 aux1 aux1 aux1 aux1 aux1\"\n    \"main1 main1 main1 main1 main1 main1\"\n    \"main2 main2 main2 main2 main2 main2\"\n    \"aux2 aux2 aux2 aux2 aux2 aux2\"\n}\n/* \n.grid.vv .main {\n  min-height : 120px;\n  min-width : 120px;\n}\n\n.grid.vv .aux {\n  min-height : 40px;\n  min-width : 244px;\n} */\n\n\n.grid.hh {\n  grid-template-areas: var( --layoutGrid );\n\n  NOgrid-template-areas: \n    \"aux1 main1 main1 main2 main2 aux2\"\n    \"aux1 main1 main1 main2 main2 aux2\"\n    \"aux1 main1 main1 main2 main2 aux2\"\n    \"aux1 main1 main1 main2 main2 aux2\"\n}\n/* \n.grid.hh .main {\n  min-height : 244px;\n  min-width : 120px;\n}\n\n.grid.hh .aux {\n  min-width : 40px;\n  min-height : 244px;\n} */\n\n\n.grid.hv {\n  grid-template-areas: var( --layoutGrid );\n\n  NOgrid-template-areas: \n    \"aux1 main1 main1 main1 main1 aux2\"\n    \"aux1 main1 main1 main1 main1 aux2\"\n    \"aux1 main2 main2 main2 main2 aux2\"\n    \"aux1 main2 main2 main2 main2 aux2\";\n}\n\n\n.swapMain, .rotateMain {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  pointer-events: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* .rotateMain {\n  position : absolute;\n  top : 54px;\n  right : 54px;\n} */\n.tlExpand {\n  position : absolute;\n  top : 8px;\n  left : 0;\n}\n\n.trExpand {\n  position : absolute;\n  top : 8px;\n  right : 0;\n}\n\n.blExpand {\n  position : absolute;\n  bottom : 8px;\n  left : 0;\n}\n\n.brExpand {\n  position : absolute;\n  bottom : 8px;\n  right : 0;\n}\n\n.expand > i {\n  transition : transform 0.3s ease;\n}\n.neg90 {\n  transform :rotate(-90deg);\n}\n\n.swapMain > *, .swapAux > *, .rotateMain > * {\n  pointer-events: all;\n  z-index:1;\n}\n\n.swapAux {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  pointer-events: none;\n  display: flex;\n}\n\n.swapAux-v {\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.swapAux-h {\n  justify-content: center;\n  align-items: flex-end;\n}\n\n.layout {\n  display : flex;\n  align-items: center\n}\n\n.area {\n  position : relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: stretch;\n  justify-self: stretch;\n  background: white;\n  border-radius: 4px;\n}\n.area > * {\n  z-index:2;\n  /* width: 100% !important;\n  height: 100% !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border : none !important; */\n}\n.area:hover {\n  background : var( --color-base050, #eeeeff )\n}\n\n.main1 {\n  grid-area : main1;\n}\n\n.main2 {\n  grid-area : main2;\n}\n\n.aux1 {\n  grid-area : aux1;\n}\n\n.aux2 {\n  grid-area : aux2;\n}\n\n.aux3 {\n  grid-area : aux3;\n}\n\n.aux4 {\n  grid-area : aux4;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `editor_evpve`,
	"grid": `grid_olv3e`,
	"vh": `vh_JCQ4z`,
	"vv": `vv__mZ1U`,
	"hh": `hh_JPKmF`,
	"hv": `hv_D2koz`,
	"swapMain": `swapMain_luKCn`,
	"rotateMain": `rotateMain_lvwfq`,
	"tlExpand": `tlExpand_ZDO_p`,
	"trExpand": `trExpand_OPYxt`,
	"blExpand": `blExpand_D_npk`,
	"brExpand": `brExpand_cXEc4`,
	"expand": `expand_M6n_P`,
	"neg90": `neg90_NU_os`,
	"swapAux": `swapAux_RY0qk`,
	"swapAux-v": `swapAux-v_XATNV`,
	"swapAux-h": `swapAux-h__m54B`,
	"layout": `layout_yP422`,
	"area": `area_I_Gy8`,
	"main1": `main1_qBjya`,
	"main2": `main2_EjfKA`,
	"aux1": `aux1_pUaYW`,
	"aux2": `aux2_fCkod`,
	"aux3": `aux3_BY3YX`,
	"aux4": `aux4_CXXHD`
};
export default ___CSS_LOADER_EXPORT___;
